import './integrations.scss';
angular.module('integrationsModule', [])

  .directive('integrationsList', ['GhDialog', function (GhDialog) {
    return {
      restrict: 'E',
      scope: {
        integrations: '='
      },

      controller: ['$scope', '$element', async function ($scope, $element) {
        $scope.showIntegrationScopes = function (service) {
          GhDialog.show({
            position: 'full',
            toolbar: false,
            template: {
              toolbar: '',
              resizable: false,
              content: /*html*/`
              <div class="integration-popup">
                <div class="cancel-container">
                  <span gh-icon="cross 0893d2 48px normal" ng-click="cancel()"></span>
                </div>
                <div class="integration-popup__name">
                  <img src="/user/integrations/icons/${service.service_id}.svg" />
                  <span>${service.service_id}</span>
                </div>
                <scopes-list scopes="service.scopes"></scopes-list>
              </div>`,
            },
            controller: ['$scope', function ($scope) {
              $scope.service = service;
            }]
          })
        }

      }],

      template: /*html*/
      
      `
      <div class="listing_table">
        <div class="listing_table_head_wrapper">
          <div class="listing_table_column bottom_line w-85">
            <div class="tab">Name</div>
          </div>
          <div class="listing_table_column w-15">
            
          </div>
        </div>
        <div class="listing_table_body_wrapper" ng-style="overflow">
          <div class="listing_table_row" ng-click="showIntegrationScopes(integration)" ng-repeat="integration in integrations">
            <div class="listing_table_column w-85">
              <span class="number">{{$index + 1}}</span>
              <span class="icon"><img src="/user/integrations/icons/{{integration.service_id}}.svg" /></span>
              <div class="name">{{integration.service_id}}</div>
            </div>
            <div class="listing_table_column w-15">
              <!--<span ng-click="showDeleteAppPopup(app)" class="delete_icon" gh-icon="rubbish 0d99ff 20px"></span>-->
            </div>

          </div>
        </div>
      </div>`
      
    }
  }])

  .directive('scopesList', [function () {

    return {
      restrict: 'E',
      scope: {
        scopes: '='
      },

      controller: ['$scope', '$element', async function ($scope, $element) {

        $scope.scopesIds = {
          email: 'Email',
          first_name: 'First name',
          last_name: 'Last name',
          picture: 'Picture',
          openid: 'Open ID',
          'https://www.googleapis.com/auth/userinfo.profile': 'Profile',
          'https://www.googleapis.com/auth/userinfo.email': 'Email',
          'https://www.googleapis.com/auth/calendar': 'Calendar'
        }

      }],

      template: /*html*/`
      <div class="listing_table">
      <div class="listing_table_head_wrapper">
        <div class="listing_table_column scope-name bottom_line w-75">
          <div class="tab">Name</div>
        </div>
        <div class="listing_table_column scope-id w-25">
          <div class="tab">Permission ID</div>
        </div>
      </div>
      <div class="listing_table_body_wrapper" ng-style="overflow">
        <div class="listing_table_row" ng-repeat="scopeItem in scopes">
          <div class="listing_table_column scope-name w-75">
            <span class="number">{{$index + 1}}</span>
            <div class="name">{{scopesIds[scopeItem]}}</div>
          </div>
          <div class="listing_table_column scope-id w-25">
          <span class="scope-id__item">
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_4255_6552)">
              <path d="M6.25 3H6V2C6 0.896973 5.10303 0 4 0C2.89697 0 2 0.896973 2 2V3H1.75C1.33667 3 1 3.3363 1 3.75V7.25C1 7.6637 1.33667 8 1.75 8H6.25C6.66333 8 7 7.6637 7 7.25V3.75C7 3.3363 6.66333 3 6.25 3ZM2.66669 2C2.66669 1.26465 3.26465 0.666687 4 0.666687C4.73535 0.666687 5.33331 1.26465 5.33331 2V3H2.66669V2Z" fill="#877230"/>
            </g>
            <defs>
              <clipPath id="clip0_4255_6552">
                <rect width="8" height="8" fill="white"/>
              </clipPath>
            </defs>
          </svg>
            <span class="id">{{scopeItem}}</span>
            </span>
          </div>

        </div>
      </div>
    </div>
      `
    }

  }]);
